/* import __COLOCATED_TEMPLATE__ from './buffer-icon-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface CellBufferIconCellSignature {
  Args: {
    cell: unknown;
    column: unknown;
    row: unknown;
    scrollToRow: unknown;
  };
}

const CellBufferIconCellComponent = templateOnlyComponent<CellBufferIconCellSignature>();

export default CellBufferIconCellComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Cell::BufferIconCell': typeof CellBufferIconCellComponent;
    'cell/buffer-icon-cell': typeof CellBufferIconCellComponent;
  }
}
